export default __webpack_public_path__ + "static/media/magzi_brand_red.2ec5d0bb.svg";